import UtilService from "../../service/UtilService";

const CustomerHistoryPatternsHeader = ({ attribute }) => {
  const label = UtilService.camelCaseToReadable(attribute);

  return (
    <>
      {label}
    </>
  );
};

export default CustomerHistoryPatternsHeader;